import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getQuickeasy1 } from '../../Apis/content';

export const QuickEasy1 = createAsyncThunk('quickeasy1', async (formData, { rejectWithValue }) => {
    try {
        const response = await getQuickeasy1(formData);
        return response?.data?.data;
    } catch (error) {
        return rejectWithValue({
            status: error.response?.status,
            data: error.response?.data,
            // optionally message
            message: error.message,
        });
    }
});

const quickeasy1Slice = createSlice({
    name: 'quickeasy1',
    initialState: {
        error: null,
        success: false,
        data: [],
        Single: [],
        tags: [],
        addOn: []
    },
    reducers: {
        clearQuickeasy1Status: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(QuickEasy1.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(QuickEasy1.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload;
                // state.data = action.payload.data.data;
            })
            .addCase(QuickEasy1.rejected, (state, action) => {
                state.error = action.payload; // now plain object
                state.success = false;
            })
    },

});
export const { clearQuickeasy1Status } = quickeasy1Slice.actions;
export default quickeasy1Slice.reducer;

